<template>
  <section>
    <v-card class="p-0">
      <v-card-text class="p-0">
        <GChart :type="chartType" :data="chartData" :options="chartOptions" />
      </v-card-text>
      <v-btn
        color="rgb(64,79,191)"
        @click="abrirCerrarDialog()"
        :loading="loading"
        dark
        block
        title="Seguimiento procesamiento"
      >
        <v-icon>timeline</v-icon>
        SEGUIMIENTO
      </v-btn>
    </v-card>
    <v-dialog v-model="dialog" persistent width="1300">
      <v-form
        @submit.prevent="cargarSeguimientoTipificacion(form)"
        v-model="valid"
        ref="form"
        lazy-validation
      >
        <v-card>
          <!-- Cabecera del formulario -->
          <v-card-title class="headline">
            <v-flex xs9>
              <v-icon>timeline</v-icon> SEGUIMIENTO PROCESAMIENTO DE CONTROL DE
              ASISTENCIA
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="abrirCerrarDialog()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md3 class="px-1">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.fecha_registro"
                  type="date"
                  label="Fecha registro"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex xs12 md3 class="px-1">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.nro_doc"
                  label="Nro documento"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex xs12 md3 class="px-1">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.nombres"
                  label="Nombres"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex xs12 md3 class="px-1">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.ap_paterno"
                  label="Ap paterno"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex xs12 md3 class="px-1">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.ap_materno"
                  label="Ap materno"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex xs12 md3 class="px-1">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.fecha_inicio"
                  type="date"
                  label="Fecha inicio"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex xs12 md3 class="px-1">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="form.fecha_fin"
                  type="date"
                  label="Fecha fin"
                  outline
                  clearable
                  success
                />
              </v-flex>
              <v-flex xs12 md3 class="px-1">
                <v-btn
                  type="submit"
                  color="rgb(64,79,191)"
                  :loading="loading"
                  dark
                  title="Buscar"
                >
                  <v-icon>search</v-icon>
                  BUSCAR
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  class="elevation-1"
                  :headers="headers"
                  :items="l_seguimiento"
                  :no-data-text="
                    loading ? 'Cargando...' : 'No se tiene registros'
                  "
                  :loading="loading"
                  item-key="index"
                  rows-per-page-text="Filas por pagina"
                  :pagination.sync="pagination"
                  :rows-per-page-items="[
                    5,
                    10,
                    20,
                    50,
                    { value: -1, text: 'Todos' }
                  ]"
                >
                  <template v-slot:headers="props">
                    <tr>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          pagination.descending ? 'desc' : 'asc',
                          header.value === pagination.sortBy ? 'active' : ''
                        ]"
                        id="cabecera_tabla"
                        class="header-comprimido"
                        @click="changeSort(header.value)"
                      >
                        <v-icon v-if="header.value" small color="white"
                          >arrow_upward</v-icon
                        >
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template v-slot:items="props">
                    <td class="text-xs-center py-0 px-2">
                      {{
                        $moment(
                          props.item.fecha_registro,
                          "YYYY-MM-DD HH:mm:ss"
                        ).format("DD/MM/YYYY HH:mm:ss")
                      }}
                    </td>
                    <td class="text-xs-center py-0 px-2">
                      {{ props.item.nro_doc }}
                    </td>
                    <td class="text-xs-center py-0 px-2">
                      {{ props.item.ap_paterno }} {{ props.item.ap_materno }}
                      {{ props.item.nombres }}
                    </td>

                    <td class="text-xs-center py-0 px-2">
                      {{
                        $moment(props.item.fecha_inicio).format("DD/MM/YYYY")
                      }}
                    </td>
                    <td class="text-xs-center py-0 px-2">
                      {{ $moment(props.item.fecha_fin).format("DD/MM/YYYY") }}
                    </td>
                    <td class="text-xs-center py-0 px-2">
                      {{
                        $moment(
                          props.item.fecha_inicio_proceso,
                          "YYYY-MM-DD HH:mm:ss"
                        ).format("DD/MM/YYYY HH:mm:ss")
                      }}
                    </td>
                    <td class="text-xs-center py-0 px-2">
                      {{
                        $moment(
                          props.item.fecha_fin_proceso,
                          "YYYY-MM-DD HH:mm:ss"
                        ).format("DD/MM/YYYY HH:mm:ss")
                      }}
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
  </section>
</template>
<script>
import { GChart } from "vue-google-charts/legacy";
export default {
  // Variables iniciales
  components: { GChart },
  props: [],
  data() {
    return {
      form: {},
      loading: false,
      labels: [],
      values: [],
      sw_marcado: true,
      // Variables grafica
      chartType: "AreaChart",
      chartData: [["Hora", "Procesos"]],
      chartOptions: {
        title: "Monitoreo procesamiento",
        hAxis: { title: "Hora", titleTextStyle: { color: "#333" } },
        vAxis: {
          title: "Nro de procesos",
          minValue: 0,
          viewWindow: {
            min: 0
          }
        },
        chartArea: { width: "80%", height: "60%" }
      },
      // Variables dialog
      valid: false,
      dialog: false,
      pagination: {
        sortBy: ""
      },
      headers: [
        {
          text: "Fecha registro",
          value: "fecha_registro",
          align: "center"
        },
        {
          text: "Cédula de identidad",
          value: "nro_doc",
          align: "center"
        },
        {
          text: "Nombre completo",
          value: "ap_paterno",
          align: "center"
        },
        {
          text: "Fecha inicio",
          value: "fecha_inicio",
          align: "center"
        },
        {
          text: "Fecha fin",
          value: "fecha_fin",
          align: "center"
        },
        {
          text: "Fecha inicio procesamiento",
          value: "fecha_inicio_proceso",
          align: "center"
        },
        {
          text: "Fecha fin procesamiento",
          value: "fecha_fin_proceso",
          align: "center"
        }
      ],
      l_seguimiento: [],
      interval_monitoreo:null
    };
  },
  async created() {
    await this.llenarDatos();
  },
  async mounted() {
    // Definimos cada cuanto se actualizara los datos
    this.interval_monitoreo = setInterval(async () => {
      await this.actualizaDatos();
    }, 5000);
  },
  destroyed() {
    clearInterval(this.interval_monitoreo); // Detener el setInterval
  },
  methods: {
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    // Metodo para llenar
    async llenarDatos() {
      var tiempo = this.$moment();
      var valor_definido = 0;
      let fila_data = [tiempo.format("HH:mm:ss"), valor_definido];
      this.chartData.push(fila_data);
    },
    async actualizaDatos() {
      try {
        const nro_max_datos = 15;
        let res = await this.$service.graphqlNotLoad({
          query: `
            query{
              nroProcesosTipificacionPasantes{
                nro_procesos
              }
            }
          `
        });
        var nro_procesos = res.nroProcesosTipificacionPasantes.nro_procesos;
        let fila_data = [this.$moment().format("HH:mm:ss"), nro_procesos];
        if (this.chartData.length > nro_max_datos) {
          this.chartData.splice(1, 1);
          this.chartData.push(fila_data);
        } else {
          this.chartData.push(fila_data);
        }
      } catch (error) {
        console.log(error);
      }
    },
    abrirCerrarDialog() {
      this.dialog = this.dialog ? false : true;
    },
    // Metodo para cargar datos en la tabla sel seguimiento
    async cargarSeguimientoTipificacion(filtros) {
      try {
        // Creamos filtros
        var filtro = [];
        for (const key in filtros) {
          if (filtros[key]) {
            filtro.push(
              `${key.toLowerCase()}:${
                typeof filtros[key] === "string"
                  ? `"${filtros[key]}"`
                  : filtros[key]
              }`
            );
          }
        }
        // Validamos que tenga al menos un filtro
        if (filtro.length == 0) {
          this.$message.info("No selecciono ningun filtro");
          this.loading = false;
          return;
        }
        var cadena_filtro = "";
        if (filtro.length > 0) {
          cadena_filtro = `(${filtro.join(",")})`;
        }
        let res = await this.$service.graphql({
          query: `
          query{
            vMonitoreoTipificacions${cadena_filtro}{
              rows{
                id_persona
                nro_doc
                ap_paterno
                ap_materno
                nombres
                fecha_inicio
                fecha_fin
                fecha_inicio_proceso
                fecha_fin_proceso
                fecha_registro
              }
            }
          }
          `
        });
        this.l_seguimiento = res.vMonitoreoTipificacions.rows;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.header-comprimido {
  background: rgb(180, 218, 233);
  white-space: pre-line !important;
  padding: 0em 0.5em 0em 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/pasantes/components/MonitoreoTipificacion.vue